export const STATISTICS_TAB_NAME = {
  Diagram: 'Diagram',
  PieChart: 'PieChart',
  Numbers: 'Numbers',
}